// Disabling this since the props spread should contain `children
// Not adding children explicitly to avoid unintentionally changing the API of this component
// Ideally, children would be marked as required on this component
/* eslint-disable jsx-a11y/anchor-has-content */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
const BiLink = (_param)=>{
    var { biData, innerRef, stopPropagation } = _param, props = _object_without_properties(_param, [
        "biData",
        "innerRef",
        "stopPropagation"
    ]);
    const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
    if (props.target === '_blank' && !props.rel) {
        props.rel = 'noreferrer';
    }
    return /*#__PURE__*/ React.createElement("a", _object_spread_props(_object_spread({}, props), {
        ref: (node)=>{
            setTrackingRef(node);
            innerRef && innerRef(node);
        }
    }));
};
BiLink.displayName = 'BiLink';
export default BiLink;
